module.exports = __webpack_public_path__ + "img/americanexpress.1799f7d9.svg";